var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topup-container"},[_c('banner-top'),_vm._m(0),_c('topup-summary')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topup-header"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Potwierdź dane doładowania")])])])
}]

export { render, staticRenderFns }